import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#999",
      "fill-rule": "evenodd",
      d: "M6.8 13.6a6.8 6.8 0 1 1 6.8-6.8 6.8 6.8 0 0 1-6.8 6.8m0-1.6a5.2 5.2 0 1 0-5.2-5.2A5.2 5.2 0 0 0 6.8 12",
      "data-name": "Path 1510"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#999",
      "fill-rule": "evenodd",
      d: "M15.766 14.634a.8.8 0 1 1-1.131 1.131l-4.16-4.16a.8.8 0 0 1 1.131-1.131Z",
      "data-name": "Path 1511"
    }, null, -1)
  ])))
}
export default { render: render }